import React from 'react'

import { useQuestionTypes } from './_load/QuestionTypesLoader'
import Draggable from '../../../../../components/dnd/Draggable'
import List from '../../../../../components/list/List'
import ListItemWrapper from '../../../../../components/list/ListItemWrapper'
import QuestionTypeIconText, { useQuestionTypeTooltip } from './QuestionTypeIconText'
import Scroll from '../../../../../components/helpers/Scroll'
import Separator from '../../../../../components/helpers/Separator'
import Sticky from '../../../../../components/helpers/Sticky'
import Tooltip from '../../../../../packages/kiti/components/presentation/Tooltip'
import dndTypes from '../_constants/dndTypes'
import { useTranslation } from 'react-i18next'

const QuestionTypeItem = ({ item, isFirst }) => {
  const { t } = useTranslation()
  const { getTooltipDescription } = useQuestionTypeTooltip()

  return (
    <Draggable item={{ questionType: item }} type={dndTypes.QUESTION} useMoveCursor>
      <ListItemWrapper>
        <Tooltip label={getTooltipDescription(item.name)} position={isFirst ? 'bottomRight' : 'topRight'} size="xsmall">
          <QuestionTypeIconText questionType={item} />
        </Tooltip>
      </ListItemWrapper>
    </Draggable>
  )
}

const QuestionTypesList = () => {
  const types = useQuestionTypes().filter(type => type.name !== 'tags')
  return (
    <Sticky>
      <Scroll maxHeight="calc(100vh - 7.5rem)" overflowY="auto">
        <List>
          {types.map((item, index) => (
            <QuestionTypeItem key={item.id} item={item} isFirst={index === 0} />
          ))}
        </List>
        <Separator weight={24} />
      </Scroll>
    </Sticky>
  )
}

export default QuestionTypesList
